import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatRadiobuttonGroup = createCustomElementWrapper('kat-radiobutton-group', 'KatRadiobuttonGroup', {
    'constraintLabel': 'constraint-label',
    'errorLabel': 'error-label',
}, {
    'onBlur': 'blur',
    'onChange': 'change',
    'onFocus': 'focus',
}, [
    'label',
]);
